<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
            <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
        </v-btn>
        <div v-html="html"></div>
    </div>
</template>

<script>
export default {
    data() {
        return { 
            html: "" ,
            snackbar_msg: "",
            color: "",
            snackbar: false,
        };
    },
    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
            that.$store.state.drawer = true;
            };
            setTimeout(() => {
            window.print();
            }, 100);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.html = localStorage.getItem("bulk_lc_html") || ""
        // setTimeout(() => window.print(), 500)
    }
}
</script>
<style scoped>
@media print {
    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }
}</style>